module.exports = __webpack_public_path__ + "img/GreekTechRamS_ua.bbeb623c.webp";